module.exports = __webpack_public_path__ + "img/wedding-3-min.3cd1d31d.png";